import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function ConfirmAccount() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutos en segundos

  // Cronómetro
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const handleConfirm = async () => {
    if (timeLeft <= 0) {
      setMessage('⏳ El código ha expirado. Solicita uno nuevo.');
      return;
    }
    try {
      await api.post('/users/confirm', { email, code });
      setMessage('🎉 ¡Felicitaciones! Tu cuenta ha sido confirmada. Prepárate para ganar 🚀');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setMessage('❌ Código inválido o error en la confirmación');
      console.error(err.response?.data || err.message);
    }
  };

  const handleResend = async () => {
    try {
      await api.post('/users/resend-code', { email });
      setMessage('📧 Nuevo código enviado a tu correo');
      setTimeLeft(120); // reinicia el cronómetro
    } catch (err) {
      setMessage('❌ No se pudo reenviar el código');
      console.error(err.response?.data || err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-green-500 to-blue-600">
      <div className="bg-white shadow-2xl rounded-xl p-8 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4">Confirmar cuenta</h2>
        <p className="mb-4 text-gray-600">Ingresa el código que recibiste en tu correo</p>

        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="border px-4 py-2 rounded w-full mb-4"
          placeholder="Código de confirmación"
        />

        <button
          onClick={handleConfirm}
          disabled={timeLeft <= 0}
          className={`px-6 py-2 rounded w-full mb-2 font-semibold transition ${
            timeLeft <= 0
              ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          Confirmar
        </button>

        <button
          onClick={handleResend}
          className="bg-yellow-400 text-black px-6 py-2 rounded hover:bg-yellow-500 transition w-full"
        >
          Reenviar código
        </button>

        {/* Cronómetro */}
        <p className="mt-4 text-red-600 font-semibold">
          Tiempo restante: {minutes}:{seconds.toString().padStart(2, '0')}
        </p>

        {/* Mensajes */}
        {message && (
          <div className="mt-4 p-3 bg-gray-100 border rounded-lg text-sm text-gray-700">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
